import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsBottom() {
  const testimonials = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    type: 'MegaPack + Kit Pro',
    quote: 'El protocolo de inspección me salvó. Compré un scooter usado y detecté 3 problemas antes de salir a la calle. Hubiera sido un desastre.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    type: 'Usuario diario',
    quote: 'El eBook de fallas es brutal. En 20 minutos diagnostiqué por qué se apagaba en las subidas. Conector flojo. Lo arreglé yo mismo.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'La Plata',
    type: 'Scooter de alta potencia',
    quote: 'La sección de 60–72V es exactamente lo que necesitaba. No existe esa info en español en ningún lado.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    type: 'Usuario',
    quote: 'El checklist de mantenimiento mensual me cambió la cabeza. Antes esperaba que se rompiera. Ahora lo prevengo.'
  }];
  return <section className="py-20 px-4" data-id="element-291">
      <div className="max-w-6xl mx-auto" data-id="element-292">
        <div className="text-center mb-12" data-id="element-293">
          <h2 className="text-3xl font-heading font-bold text-white" data-id="element-294">
            ❤️ MÁS USUARIOS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-295">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-surface border border-border rounded-2xl p-6" data-id="element-296">
              <div className="flex items-start justify-between mb-4" data-id="element-297">
                <div className="flex items-center gap-4" data-id="element-298">
                  <div className="w-12 h-12 rounded-full bg-brand/10 text-brand flex items-center justify-center font-bold text-lg shrink-0" data-id="element-299">
                    {t.initials}
                  </div>
                  <div data-id="element-300">
                    <div className="font-bold text-white flex items-center gap-2" data-id="element-301">
                      {t.name}
                      <span className="text-xs font-normal text-muted bg-background px-2 py-0.5 rounded-full" data-id="element-302">
                        📍 {t.location}
                      </span>
                    </div>
                    <div className="text-sm text-brand" data-id="element-303">{t.type}</div>
                  </div>
                </div>
              </div>
              <div className="flex gap-1 mb-3" data-id="element-304">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-accent text-accent" data-id="element-305" />)}
              </div>
              <p className="text-gray-300 italic" data-id="element-306">"{t.quote}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}